export default "__VITE_ASSET__CpHIzCZn__"